



































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'up-tags' })
export default class UpTags extends Vue {
  @Prop({ default: 'info' })
  private tagType?: 'info' | '' | 'success' | 'warning' | 'danger';

  @Prop({ default: '+ New Tag' })
  private buttonText?: string;

  @Prop({ default: '' })
  private title?: string;

  @Prop({ default: false })
  private isLoading?: boolean;

  @Prop({ required: true })
  private tags!: any[];

  @Prop({ default: '' })
  private valueKey!: string;

  @Prop({ default: true })
  private canAdd!: boolean;

  private isShowInput: boolean = false;
  private newTag: string = '';

  showInput() {
    this.isShowInput = true;
    this.$nextTick(() => {
      ((this.$refs.newTagInput as Vue).$refs.input as HTMLElement).focus();
    });
  }

  onRemove(tag: string) {
    this.$emit('remove', tag);
  }

  onEnter() {
    let newTag = this.newTag;
    if (newTag) {
      this.$emit('enter', newTag);
    }
    this.isShowInput = false;
    this.newTag = '';
  }
}
